import React from 'react';
import calendar from 'assets/icons/calendar.svg';
import 'assets/scss/attention-time.scss';

export const AttentionTime = () => {
	return (
		<div className="attentiontime body primary-color">
			<p>
				<b>Nuestros horarios de atención son:</b>{' '}
			</p>
			<div className="attentiontime-content">
				<img src={calendar} className="attentiontime-icon" alt="icon" />
				<div style={{ textAlign: 'left', marginLeft: 10 }}>
					<p style={{ marginTop: 8 }}>Lunes a Jueves de 8:30 a 18:00 hrs.</p>
					<p>Viernes de 8:30 a 16:00 hrs.</p>
				</div>
			</div>
		</div>
	);
};
